import { z } from "zod";

import { ExperienceDtoSchema } from "../../../dtos/experiences";

export const GetExperiencesResponseBodySchema = z.object({
  experiences: ExperienceDtoSchema.array(),
});

export type GetExperiencesResponseBodyType = z.infer<
  typeof GetExperiencesResponseBodySchema
>;
